import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import prepareAuthHeaders from "@utils/prepareAuthHeaders";
import { ListResponse } from "@models/list-response";
import { Label } from "@models/label";

const BASE_API_URL = process.env.REACT_APP_API_URL;

export const labelApi = createApi({
  reducerPath: "labelApi",
  baseQuery: fetchBaseQuery({
    baseUrl: `${BASE_API_URL}/labels`,
    prepareHeaders: prepareAuthHeaders,
  }),
  endpoints: (builder) => ({
    getLabels: builder.query<ListResponse<Label>, { patientId: string }>({
      query: (params) => ({
        url: "",
        method: "GET",
        params,
      }),
    }),
  }),
});

export const { useGetLabelsQuery } = labelApi;
